const CONCERNS = [
  'Dryness',
  'Oiliness',
  'Uneven skin tone',
  'Sun exposure',
  'Dullness',
  'Dark spots',
  'Blemishes',
  'Pores',
  'Stressed skin',
  'Fine lines & wrinkles',
  'Loss of firmness',
  'Redness',
  'Loss of elasticity',
  'Uneven skin texture',
];

export default CONCERNS;
